import { Link } from 'react-router';
import GithubIcon from '../socials/github';
import TelegramIcon from '../socials/telegram';
import TwitterIcon from '../socials/twitter';

export default function Footer() {
   return (
     <footer className="relative mx-4 flex flex-col items-center justify-between space-y-4 pb-8 pt-20 lg:container lg:mx-auto lg:flex-row lg:space-x-4 lg:space-y-0">
       <ul className="flex items-center space-x-4">
         <li className="border-b-2 border-transparent hover:border-white">
           <Link to={`/liquidity/add`}>
             RSwap
           </Link>
         </li>
       </ul>
       <div className="flex items-center space-x-4">
         <p className="hover:text-primary-100">
           <a href="https://t.me/RedDicks_XRD" target="_blank">
             <TelegramIcon />
           </a>
         </p>
         <p className="hover:text-primary-100">
           <a href="https://x.com/REDDICKS_XRD" target="_blank">
             <TwitterIcon />
           </a>
         </p>
         {/* <p className="hover:text-primary-100">
           <a href="https://github.com/OmegaSyndicate" target="_blank">
             <GithubIcon />
           </a>
         </p> */}
       </div>
     </footer>
   );
}
